// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"24":"617b689c","71":"32bfaad6","249":"945f0bdd","278":"c73740f0","594":"6dc91ce4","710":"5b765b21","719":"06c67ca6","791":"96bcdeb9"}[chunkId] + ".js";
};